/**
 * Small per-user UI preferences kept in localStorage.
 *
 * Namespaced by user id, because two people sharing a front-desk machine
 * should not inherit each other's dashboard scope. Deliberately not stored on
 * the server: these are display choices, and a `User.preferences` column is
 * the wrong place to start keeping UI state.
 *
 * Theme and density are the exception — they live in ThemeProvider, because
 * they must also be applied before first paint by public/theme-init.js.
 */

import { type StoredChoices, readStoredChoice, writeStored } from './storage';

const PREFIX = 'ndc.pref';

function key(userId: number | undefined, name: string): string {
  return `${PREFIX}.${userId ?? 'anon'}.${name}`;
}

export function readPreference<T extends string>(
  userId: number | undefined,
  name: string,
  choices: StoredChoices<T>,
): T {
  return readStoredChoice(key(userId, name), choices);
}

export function writePreference(userId: number | undefined, name: string, value: string): void {
  writeStored(key(userId, name), value);
}
